{
    "termFees": "Term Fees",
    "typeFees" : "Type Fees",
    "transportFees" : "Transport Fees",
    "otherFees" : "Other Fees",
    "studentId" : "Student Id",
    "ascending" : "Ascending",
    "descending" : "Descending",
    "ascendingValue" : "asc",
    "descendingValue" : "desc",
    "rollNumber" : "Roll Number",
    "allValue" : "All",
    "noneValue" : "None",
    "registartionNumber" : "registration_number",
    "rollNumberValue" : "roll_number",
    "studentView" : "studentView",
    "classView" : "classView"

}